// Abrir (y por lo tanto imprimir) el PDF de una factura desde el backoffice.
//
// `GET /invoice/file/:id` y `GET /invoice/received/file/:id` son endpoints AUTENTICADOS
// (`backend/src/utils/enpoints.js`, rols [1,2,4]): el middleware global exige el header
// `access-token`. `window.open(url)` es una navegación del browser y no puede mandar
// headers, así que la pestaña nueva recibía el JSON {"error":1002,"message":"La sesión
// expiró"} en lugar del comprobante — desde afuera parece que las facturas "quedaron bajo
// seguridad", pero la sesión está perfecta: el pedido sale sin token.
//
// Antes de ENI-76 el matcher del backend comparaba por substring y `/invoice/file/<id>`
// caía en la entrada TOKENLESS `/invoice`, así que el PDF se servía sin ningún token: el
// `window.open` andaba, pero cualquiera con el id se bajaba una factura ajena. Por eso el
// arreglo va acá y no aflojando el endpoint: se baja el PDF con fetch —que sí manda el
// `access-token`, y el `x-branch-id` se lo agrega el interceptor de `utils/branch.js`, cosa
// que el window.open tampoco hacía— y se abre el blob resultante.

import { endSession } from './session';

var config = process.env;

// El blob vive en ESTE documento: si el caller navega (AddInvoicePage vuelve a /purchase)
// antes de que la pestaña nueva termine de leerlo, el browser lo revoca y queda en blanco.
function waitForTabLoad(tab) {
    return new Promise((resolve) => {
        const timer = setTimeout(resolve, 3000);
        try {
            tab.addEventListener('load', () => { clearTimeout(timer); resolve(); }, { once: true });
        } catch (error) {
            // Si el browser no deja engancharse a la pestaña nueva, el timeout alcanza.
        }
    });
}

// `path` es la ruta relativa a la API, sin la base: 'invoice/file/<id>'.
export async function openInvoiceFile(path) {
    // La pestaña se abre SINCRÓNICAMENTE, dentro del gesto del click: abrirla después del
    // await la deja a merced del bloqueador de popups.
    const tab = window.open('', '_blank');

    try {
        const response = await fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + path, {
            method: 'GET',
            headers: { 'access-token': localStorage.getItem('token') },
        });

        // El backend contesta TODOS los errores como HTTP 200 con body JSON {error, message}
        // (sesión vencida 1002, factura inexistente, PyMO caído): `response.ok` no alcanza.
        // Sin este chequeo la pestaña mostraría el JSON del error como si fuera la factura,
        // que es exactamente lo que venía pasando.
        if ((response.headers.get('content-type') || '').includes('json')) {
            const data = await response.json();
            if (tab) {
                tab.close();
            }
            alert(data.message || 'No se pudo abrir la factura.');
            if (Number(data.error) === 1002) {
                endSession();
            }
            return false;
        }

        const blobUrl = URL.createObjectURL(await response.blob());

        if (tab) {
            tab.location = blobUrl;
            await waitForTabLoad(tab);
        } else {
            // Popup bloqueado (pasa cuando el open no nace de un click, p.ej. al volver de
            // emitir una factura): al menos se baja el archivo en vez de perderlo.
            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = 'factura.pdf';
            link.click();
        }

        // Recién acá se libera: revocarlo en el acto deja la pestaña sin nada que mostrar.
        setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
        return true;
    } catch (error) {
        if (tab) {
            tab.close();
        }
        console.error('No se pudo abrir la factura:', error);
        alert('No se pudo abrir la factura.');
        return false;
    }
}
